import React, { useEffect, useRef } from "react";
import { ChevronRightIcon, MessageCircleIcon } from "lucide-react";
import { useReducedMotion } from "framer-motion";
type CustomerCommentsProps = {
  screenshots: ReadonlyArray<string>;
};
export function CustomerComments({
  screenshots
}: CustomerCommentsProps) {
  const carouselRef = useRef<HTMLDivElement>(null);
  const pausedRef = useRef(false);
  const reducedMotion = useReducedMotion();
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel || reducedMotion || screenshots.length < 2) return;
    const interval = window.setInterval(() => {
      if (pausedRef.current) return;
      const nextCard = carousel.querySelector<HTMLElement>("[data-comment-card]");
      if (!nextCard) return;
      const step = nextCard.offsetWidth + 16;
      const atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 8;
      carousel.scrollTo({
        left: atEnd ? 0 : carousel.scrollLeft + step,
        behavior: "smooth"
      });
    }, 4800);
    return () => window.clearInterval(interval);
  }, [reducedMotion, screenshots.length]);
  if (screenshots.length === 0) return null;
  function pauseCarousel() {
    pausedRef.current = true;
  }
  function resumeCarousel() {
    pausedRef.current = false;
  }
  return <div data-id="element-8" data-mp="331ylv07hw2tv">
      <p className="mt-5 inline-flex items-center gap-1 text-xs font-semibold text-stone-500 md:hidden" data-id="element-9" data-mp="382me1p7gmppo"><ChevronRightIcon className="h-4 w-4 text-lime-600" aria-hidden="true" data-id="element-10" data-mp="2bclpnrb06b8w" />Deslizá para ver más experiencias</p>
      <div ref={carouselRef} className="mt-4 overflow-x-auto pb-4 pr-5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Comentarios reales de personas que accedieron al material" onPointerEnter={pauseCarousel} onPointerLeave={resumeCarousel} onPointerDown={pauseCarousel} onPointerUp={resumeCarousel} onTouchStart={pauseCarousel} onTouchEnd={resumeCarousel} onFocusCapture={pauseCarousel} onBlurCapture={resumeCarousel} data-id="element-11" data-mp="2fdp9eow68rfe">
        <div className="flex snap-x snap-mandatory gap-4" data-id="element-12" data-mp="1wlcw573zc5qh">
          {screenshots.map((screenshot, index) => <div key={screenshot} className="w-[82%] shrink-0 snap-start sm:w-[48%] lg:w-[31.5%]" data-id="element-13" data-mp="2uzjsim9q5i2e" data-mpi={index}>
              <figure data-comment-card tabIndex={0} className="flex h-[440px] items-center justify-center overflow-hidden rounded-2xl border border-stone-200 bg-[#fffefb] p-3 shadow-[0_5px_16px_rgba(30,38,25,0.07)] outline-none transition-[transform,box-shadow] duration-200 [transition-timing-function:cubic-bezier(0.22,1,0.36,1)] focus-visible:-translate-y-0.5 focus-visible:ring-4 focus-visible:ring-lime-300 sm:h-[480px]" data-id="element-14" data-mp="38qx8jq8fbxso">
                <img src={screenshot} alt={`Comentario real de una persona que accedió al material ${index + 1}`} className="h-full w-full rounded-xl object-contain" loading="eager" fetchPriority={index < 3 ? "high" : "auto"} data-id="element-15" data-mp="2q0pavnnhtzjv" />
              </figure>
            </div>)}
        </div>
      </div>
    </div>;
}
export function CommentsTrustLine() {
  return <p className="mt-5 inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.13em] text-emerald-800" data-id="element-16" data-mp="8s5jflb03pgp"><MessageCircleIcon className="h-4 w-4 text-lime-600" aria-hidden="true" data-id="element-17" data-mp="cu8wgedbj243" />Personas reales <span className="text-stone-400" data-id="element-18" data-mp="3uzlx0273mdhl">•</span> Experiencias reales</p>;
}